import { matchPath } from 'react-router-dom';

import { FinanceProvider, Job } from '@kanda-libs/ks-frontend-services';

import { URLS } from 'config';

import { ApplyPage } from './context';

export const getProvider = (
  job: Job | undefined,
): FinanceProvider | undefined =>
  job?.customer_options?.finance_option?.provider;

export const matchPathToPage = (pathname: string): ApplyPage | undefined => {
  if (
    matchPath(pathname, {
      path: URLS.applyForFinance,
      exact: true,
      strict: false,
    })
  )
    return 'WELCOME';
  if (
    matchPath(pathname, {
      path: URLS.applyForFinanceTermsAndConditions,
      exact: true,
      strict: false,
    })
  )
    return 'TERMS_AND_CONDITIONS';
  if (
    matchPath(pathname, {
      path: URLS.applyForFinanceDetails,
      exact: true,
      strict: false,
    })
  )
    return 'YOUR_INFO';
  return undefined;
};

export const safeJsonParse = <T>(str: string): T | undefined => {
  try {
    const parsed = JSON.parse(str);
    return parsed as T;
  } catch (_) {
    return undefined;
  }
};
